const constant = {
  RESEND_OTP_INTERVAL: 25,
  TOAST_DURATION: 3000,
  USER_ROLE: ["researcher", "participant"],
  SUPPORT_TYPE: ["Website Queries", "Help"],
};

export default constant;
